import * as MobileDetect from "mobile-detect";
import { createElement, Component, createContext } from "react";
import MediaQuery from "react-responsive";

var breakPoints = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1200
},
    defaultSizes = {
  phone: breakPoints.sm - 1,
  tablet: breakPoints.md - 1,
  desktop: breakPoints.lg
},
    parser = function parser(e) {
  var t = (void 0 === e ? {} : e).headers,
      o = void 0 === t ? {} : t,
      n = o["user-agent"] || o["User-Agent"],
      r = new MobileDetect(n);
  return {
    desktop: !r.mobile(),
    mobile: !!r.mobile(),
    phone: !!r.phone(),
    tablet: !!r.tablet()
  };
},
    Responsive = function () {
  function e(e) {
    this.fakeWidth = defaultSizes.desktop, e && this.update(e);
  }

  return e.prototype.update = function (e) {
    var t = parser(e),
        o = t.phone,
        n = void 0 !== o && o,
        r = t.tablet,
        i = void 0 !== r && r,
        s = t.mobile,
        a = void 0 !== s && s;
    t.desktop;
    this.fakeWidth = a ? n ? defaultSizes.phone : i ? defaultSizes.tablet : defaultSizes.phone : defaultSizes.desktop;
  }, e;
}(),
    extendStatics = Object.setPrototypeOf || {
  __proto__: []
} instanceof Array && function (e, t) {
  e.__proto__ = t;
} || function (e, t) {
  for (var o in t) {
    t.hasOwnProperty(o) && (e[o] = t[o]);
  }
};

function __extends(e, t) {
  function o() {
    this.constructor = e;
  }

  extendStatics(e, t), e.prototype = null === t ? Object.create(t) : (o.prototype = t.prototype, new o());
}

var __assign = Object.assign || function (e) {
  for (var t, o = 1, n = arguments.length; o < n; o++) {
    for (var r in t = arguments[o]) {
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
  }

  return e;
};

function __rest(e, t) {
  var o = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (n = Object.getOwnPropertySymbols(e); r < n.length; r++) {
      t.indexOf(n[r]) < 0 && (o[n[r]] = e[n[r]]);
    }
  }

  return o;
}

var context = createContext(null),
    ResponsiveProvider = context.Provider,
    ResponsiveConsumer = context.Consumer;

function withResponsive(e) {
  return function (t) {
    return createElement(ResponsiveConsumer, null, function (o) {
      return createElement(e, __assign({}, t, {
        responsive: o
      }));
    });
  };
}

var isBrowser = !("undefined" == typeof window || !window.document || !window.document.createElement),
    MediaQueryComponent = function (e) {
  function t(t) {
    var o = e.call(this, t) || this;
    return o.state = {
      isMounted: !Boolean(t.responsive)
    }, o;
  }

  return __extends(t, e), t.prototype.componentDidMount = function () {
    !this.state.isMounted && isBrowser && this.setState(function () {
      return {
        isMounted: !0
      };
    });
  }, t.prototype.render = function () {
    var e = this.props,
        t = e.responsive,
        o = __rest(e, ["responsive"]),
        n = this.state.isMounted ? void 0 : {
      deviceWidth: t && t.fakeWidth,
      width: t && t.fakeWidth
    };

    return createElement(MediaQuery, __assign({
      values: n
    }, o));
  }, t;
}(Component),
    MediaQuerySSR = withResponsive(MediaQueryComponent);

export { Responsive, MediaQuerySSR, ResponsiveProvider, ResponsiveConsumer, withResponsive, breakPoints, defaultSizes, parser };